"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomLoader = void 0;
const react_1 = __importStar(require("react"));
const CustomLoader_styles_1 = require("./CustomLoader.styles");
const CustomLoader = ({ count, exportLabel, loading, customLoaderMessage }) => {
    const [sliderValue, setSliderValue] = (0, react_1.useState)(0);
    const [sliderShowValue, setSliderShowValue] = (0, react_1.useState)(0);
    const [showMessage, setShowMessage] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            if (sliderValue + 99 / count >= 99 && loading) {
                setSliderValue(99);
                setTimeout(() => {
                    setShowMessage(true);
                }, 3000);
                clearInterval(interval);
                return;
            }
            if (sliderValue + 99 / count >= 99 && !loading) {
                setSliderValue(99);
                clearInterval(interval);
                return;
            }
            if (count) {
                setSliderValue(+(sliderValue + 99 / count).toFixed(2));
            }
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [count, sliderValue, loading]);
    (0, react_1.useEffect)(() => {
        setSliderShowValue(+sliderValue.toFixed(0));
    }, [count, sliderValue]);
    return (react_1.default.createElement(CustomLoader_styles_1.Container, null,
        react_1.default.createElement(CustomLoader_styles_1.CustomLoaderCount, null,
            react_1.default.createElement(react_1.default.Fragment, null, `${exportLabel} (${sliderShowValue}%)`)),
        react_1.default.createElement(CustomLoader_styles_1.CustomLoaderTrack, null,
            react_1.default.createElement(CustomLoader_styles_1.CustomLoaderRange, { "$count": sliderValue })),
        showMessage && react_1.default.createElement(CustomLoader_styles_1.CustomLoaderMessage, null, customLoaderMessage)));
};
exports.CustomLoader = CustomLoader;
exports.default = exports.CustomLoader;
//# sourceMappingURL=CustomLoader.js.map